import { Shops } from '@infrab4a/connect';

export const ShopMap: Record<Shops, string> = {
  [Shops.GLAMSHOP]: 'Glam',
  [Shops.MENSMARKET]: "Men's Market",
  [Shops.GLAMPOINTS]: 'Vitrine Glam',
  [Shops.GLAMBEAUTY]: 'Glambeauty',
  [Shops.ELLA]: 'Ella',
  [Shops.ALL]: 'Todas'
};

export function getShop(name: string): Shops | undefined {
  return (Object.values(Shops) as Shops[]).find(
    (shop) => shop.toLowerCase() === name?.toLowerCase()
  );
}

export function getShopLabel(name: string): string {
  const shop = getShop(name);
  return shop ? ShopMap[shop] : name;
}

export function getShopsArray(): Array<{ label: string; value: Shops }> {
  return (Object.values(Shops) as Shops[])
    .filter((shop) => shop !== Shops.ALL)
    .map((value) => ({
      label: ShopMap[value],
      value
    }));
}

export function getAllShopsArray(): Array<{ label: string; value: Shops }> {
  return (Object.values(Shops) as Shops[]).map((value) => ({
    label: ShopMap[value],
    value
  }));
}
